import { LOOP_RESTING_OPACITY } from '@/constants/contentFeed';

// Everything around the media rests dimmed so the media itself holds the focus; whatever
// the viewer points at comes back to full strength. Hovering the details block lifts the
// whole block, hovering a control lifts just that control — the highlight tracks what you
// are actually pointing at.
//
// `_focusWithin` matters as much as `_hover`: without it a keyboard user would tab
// through controls that stay dimmed, with no indication of where they are.
const transition = 'opacity 0.2s ease';

// For a group of related elements — the attribution/details column — lifted as one.
export const dimUntilHoverGroup = {
  opacity: LOOP_RESTING_OPACITY,
  transition,
  _hover: { opacity: 1 },
  _focusWithin: { opacity: 1 },
} as const;

// For a single control, lifted on its own.
export const dimUntilHoverControl = {
  opacity: LOOP_RESTING_OPACITY,
  transition,
  _hover: { opacity: 1 },
  _focusVisible: { opacity: 1 },
} as const;
